import { render, staticRenderFns } from "./BookingFlightView.vue?vue&type=template&id=56c04924&scoped=true&"
import script from "./BookingFlightView.vue?vue&type=script&lang=js&"
export * from "./BookingFlightView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c04924",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c04924')) {
      api.createRecord('56c04924', component.options)
    } else {
      api.reload('56c04924', component.options)
    }
    module.hot.accept("./BookingFlightView.vue?vue&type=template&id=56c04924&scoped=true&", function () {
      api.rerender('56c04924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingFlightView.vue"
export default component.exports